// 通用下载页容器
import React from 'react'
import { isIOS } from '@bihu/common-js'
import DownloadSkinContainer from '@/pages/application-flow-skins/download/download-skin-container'
import useV2PageDownloadBusinessBridge from './hooks/use-v2-download-business-bridge'

interface Props {}

const DownloadPage: React.FC<Props> = () => {
  // --------------------------------------------------------------------------
  // v2 新皮肤接入区块：
  // 业务归属：完全由同一页面目录内的 useV2PageDownloadBusinessBridge 拥有，
  // 包括渠道配置解析、版本接口请求、微信判断以及回退逻辑。
  // --------------------------------------------------------------------------
  const {
    brandName,
    closeWechatTip,
    handleDownload,
    isDownloadReady,
    isJhjBrand,
    isLoadingChannel,
    showWechatTip,
    theme,
  } = useV2PageDownloadBusinessBridge()

  // 若正在向后端查询渠道详情，暂不渲染页面，解决刷新闪现问题
  if (isLoadingChannel || !theme) {
    return <div />
  }

  return (
    <DownloadSkinContainer
      model={{
        brandName,
        isDownloadReady,
        isIOS,
        isJhjBrand,
        showWechatTip,
      }}
      onCloseWechatTip={closeWechatTip}
      onDownload={handleDownload}
      theme={theme}
    />
  )
}

export default DownloadPage
